import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    activeTab: 'attendees'
};

const registrationSlice = createSlice({
    name: 'registration',
    initialState,
    reducers: {
        setActiveTab: (state, action) => {
            state.activeTab = action.payload;
        }
    }
});

export const { setActiveTab } = registrationSlice.actions;

export default registrationSlice.reducer;
